// Motorcycle Storage content

import TwentyFourHourIcon from 'assets/images/psp/twentyfour-hour.svg';
import Camera from 'assets/images/psp/camera.svg';
import Garage from 'assets/images/psp/garage.svg';
import Electricity from 'assets/images/psp/MotorCycle/electricity.svg';
import Insurance from 'assets/images/psp/MotorCycle/insurance.svg';
import Seasonal from 'assets/images/psp/MotorCycle/seasonal.svg';
import Theft from 'assets/images/psp/MotorCycle/theft.svg';
import SaveMoney from 'assets/images/psp/save-money.svg';
import PaperWork from 'assets/images/psp/paperwork.svg';
import Summer from 'assets/images/psp/summer.svg';

import MotorCycleHero from 'assets/images/psp/hero/motorcycle-hero.webp';
import Indoor from 'assets/images/psp/MotorCycle/indoor.webp';
import Outdoor from 'assets/images/psp/MotorCycle/outdoor.jpg';
import Motorcycle1 from 'assets/images/psp/FeaturedImages/motorcycle1.webp';
import Motorcycle2 from 'assets/images/psp/FeaturedImages/car4.webp';
import Motorcycle3 from 'assets/images/psp/FeaturedImages/self3.webp';
import Motorcycle4 from 'assets/images/psp/FeaturedImages/climate1.webp';

const metadata = {
	title: 'Find Motorcycle Storage Near You | SpareFoot',
	description:
		'Find the best Motorcycle storage near you. Discover the best Motorcycle storage nearby — view prices, photos, availability, and reviews for local facilities!',
};

const reviews = [
	{
		reviewTitle: 'Easy to use - SpareFoot',
		link: 'https://www.trustpilot.com/users/555f48210000ff0001c0d067',
		reviewRating: 5,
		reviewText:
			'Found a new storage place in no time for my motorcycle with SpareFoot. If you live in an apartment complex and they don’t have garages, I’d strongly suggest you invest in good storage.',
		reviewerName: 'Kay Jay',
		reviewerInitials: 'KJ',

		reviewDate: '',
	},
	{
		reviewTitle: 'Very easy to reserve a storage unit at a GREAT rate!',
		link: 'https://www.trustpilot.com/reviews/543fef860000640002ace261',
		reviewRating: 5,
		reviewText:
			'I was looking for a storage unit to store my husband’s motorcycle for the winter months and all the other facilities’ rates were too high. I found SpareFoot and reserved a 5x10 unit for the first of next month for half the price of the others! I’m totally impressed with the customer service! I’ll be a customer here for as long as my husband owns his motorcycle!',
		reviewerName: 'Stefanie Chiguer',
		reviewerInitials: 'SC',

		reviewDate: '',
	},
	{
		reviewTitle: 'Very convenient to find and book storage.',
		link: 'https://www.trustpilot.com/reviews/53c93dda000064000298d6bf',
		reviewRating: 5,
		reviewText:
			'I found SpareFoot online looking for a storage unit for my motorcycle. The site was awesome as it condensed all the local storage facilities into one site with the rate. I was able to book right online once I found the best unit to suit my needs. I would highly recommend the site.',
		reviewerName: 'Chris',
		reviewerInitials: 'C',

		reviewDate: '',
	},
	{
		reviewTitle: 'Easy to use and cheap!',
		link: 'https://www.trustpilot.com/reviews/535e8e6100006400028668ec',
		reviewRating: 5,
		reviewText:
			'I made one call after moving cross country, needing to drop off my trailer and motorcycle so I could use my truck to find a place to live. In a matter of minutes SpareFoot found me a place that had a unit for $1 for the first month. The managers there are fantastic and the place is great! Huge lifesaver in an otherwise super hectic time. Thank you :)',
		reviewerName: 'Zach',
		reviewerInitials: 'Z',

		reviewDate: '',
	},
];

const motorcycleStorageFAQs = [
	{
		question: 'Q: Can I store a motorcycle in a storage unit?',
		answer: '**A:** Absolutely! Storing your motorcycle in a self-storage unit is one of the smartest ways to protect your investment. At SpareFoot, we help thousands of riders find secure storage facilities that store motorcycles. Most storage facilities specifically accommodate motorcycles and other vehicles, offering both indoor and outdoor options to fit your budget and protection needs. Indoor units provide the best security and weather protection, while outdoor vehicle storage offers a more affordable solution for short-term needs.',
	},
	{
		question: 'Q: Can a motorcycle fit in a 5x5 storage unit?',
		answer: '**A:** In short, yes. However, while a 5x5 storage unit can fit certain motorcycles, it might be a tight squeeze. Small bikes like scooters, mopeds, and compact dirt bikes typically fit well in a 5x5 unit, which offers 25 square feet and 8 feet of height. However, most standard motorcycles, especially touring bikes, cruisers, and larger sport bikes, will be cramped in this size. We generally recommend a 5x10 unit for most motorcycles, as it provides enough space to comfortably maneuver your bike in and out, plus room for helmets, riding gear, and basic maintenance. The extra space is worth the modest price increase for the convenience and protection it offers.',
	},
	{
		question: 'Q: How often should you start a motorcycle in storage?',
		answer: '**A:** For motorcycles in storage, we recommend starting your bike every 2–4 weeks, but this depends on how you’ve prepared it for storage. If you’ve properly winterized your motorcycle with fuel stabilizer and a battery tender, you can go longer between starts – potentially the entire storage season without starting it.',
	},
	{
		question: 'Q: How to winterize my motorcycle for storage?',
		answer:
			'**A:** SpareFoot has a helpful [guide on how to winterize a motorcycle for storage](https://sparefoot.com/blog/how-to-winterize-and-store-your-motorcycle), a crucial step in long-term motorcycle storage. Start by thoroughly cleaning your bike to prevent corrosion and inspect for any damage that should be addressed before storage.\n\n' +
			'For fuel preparation, either drain the tank completely or fill it with fresh gas and add fuel stabilizer, then run the engine to circulate the treated fuel through the system. Change the oil and filter since old oil contains contaminants that can damage your engine during storage. Remove the battery and store it in a cool, dry place with a battery tender, or connect a tender directly to the bike if your storage unit has electrical outlets.\n\n' +
			'Protect your tires by inflating them to proper pressure and ideally placing the bike on a center stand or paddock stands to prevent flat spots.',
	},
	{
		question: 'Q: Can I find climate-controlled motorcycle storage?',
		answer: '**A:** Yes! Climate-controlled motorcycle storage is widely available through SpareFoot’s network of storage facilities. Climate-controlled units maintain consistent temperature and humidity levels, typically between 55–85°F with humidity control, making them ideal for protecting valuable, vintage, or sensitive motorcycles from extreme weather conditions. Through SpareFoot, you can easily filter search results to show only climate-controlled facilities in your area. SpareFoot will show you units in major operators like Extra Space Storage, Public Storage, and CubeSmart, as well as smaller, locally owned facilities, all of which may offer climate-controlled options.',
	},
];

export const MotorcycleStorageContent = {
	metadata,
	type: 'Motorcycle',
	sections: [
		{
			title: 'Motor Cycle Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Motorcycle Storage For You',
							description:
								'Your motorcycle is a symbol of freedom, joy, and travel, and deserves to be treated as such. Proper motorcycle storage is your best friend when it comes to preserving your motorcycle and the happiness it brings. Motorcycle self-storage offers the perfect solution with climate-controlled units that shield your motorcycle from temperature extremes and humidity while providing secure, accessible space whenever you need it.',
							image: MotorCycleHero,
							CTAText: 'Search Motorcycle Storage Facilities',
						},
					},
				},
			],
		},

		{
			title: 'nearby storage',
			background: 'gray',
			nopaddingBottom: true,
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Find Storage Near You',
					},
				},
			],
		},

		{
			title: 'Why You Should Put Your Motorcycle in Storage',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Why You Should Put Your Motorcycle in Storage',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Putting your motorcycle in storage keeps your bike secure and protected from the elements when you're not hitting the open road. With convenient facilities near your home, accessing your stored motorcycle is as simple as pulling it from your garage – but with the added security and climate protection that your driveway or overcrowded garage can't match.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Benefit',
								key: 'Benefit',
							},
							{
								label: 'Description',
								key: 'Description',
							},
						],
						columnWidths: [1, 2],
						rows: [
							{
								Benefit: {
									type: 'icon',
									icon: Seasonal,
									heading: 'Weather Protection',
								},

								Description:
									'Climate-controlled units prevent rust, corrosion, and damage from rain, snow, UV rays, and extreme temperatures, making winter motorcycle storage woes a thing of the past.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: Camera,
									heading: 'Enhanced Security',
								},
								Description:
									'Professional security systems, gated access, and surveillance cameras provide better protection than home garages.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: Garage,
									heading: 'Space Savings',
								},

								Description:
									'Free up valuable garage and driveway space at home for other uses.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: Summer,
									heading: 'Seasonal Storage',
								},

								Description:
									'Perfect solution for riders in harsh winter climates who store bikes for months at a time.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: Theft,
									heading: 'Theft Prevention',
								},

								Description:
									'Secure facilities with controlled access significantly reduce the risk of motorcycle theft.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: TwentyFourHourIcon,
									heading: 'Convenience',
								},

								Description:
									'Easy access when you want to ride, without moving cars or clearing garage clutter.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: Insurance,
									heading: 'Insurance Benefits',
								},

								Description:
									'Many insurance companies offer reduced premiums for motorcycles stored in secure facilities.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: Electricity,
									heading: 'Maintenance Friendly',
								},

								Description:
									'A clean, dry environment is ideal for performing maintenance and repairs. Motorcycle storage units with electricity also allow you to periodically inspect your bike in a well-lit environment while in storage.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: PaperWork,
									heading: 'Flexible Terms',
								},

								Description:
									'Month-to-month options accommodate changing storage needs without long commitments.',
							},
							{
								Benefit: {
									type: 'icon',
									icon: SaveMoney,
									heading: 'Cost Effective',
								},

								Description:
									'Often cheaper than building additional garage space or risking expensive weather and theft damage.',
							},
						],
					},
				},
			],
		},

		{
			title: 'video content',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					props: {
						content: {
							title: 'Motorcycle Storage Unit Size Guide ',
							description:
								"Choosing the right storage unit size for your motorcycle depends on your bike's dimensions, how much gear you plan to store, and whether you need space to move around for maintenance. While most motorcycles can fit in smaller units, having extra room for helmets, riding gear, tools, and easy maneuvering makes the storage experience much more convenient. Use this guide to find the perfect fit for your two-wheeled investment. \n\n*Prices vary by location and amenities like climate control",
						},
						src: 'https://www.youtube.com/embed/9wnmg0-Zs0w',
					},
				},
			],
		},

		{
			title: 'Motorcycle Storage Unit Size Guide',
			modules: [
				{
					type: 'sizeChart',
					props: {
						title: 'Understanding Motorcycle Storage Unit Sizes',
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Dimensions',
								key: 'Dimensions',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
							{
								label: 'Monthly Cost Range*',
								key: 'Monthly Cost Range*',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**5x5**',
								},
								Dimensions: "5' × 5' × 8'",
								'Best For': 'Compact bikes only',
								'What Fits':
									'Small scooters, mopeds, dirt bikes',
								'Monthly Cost Range*': '$30 - $60',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**5x10**',
								},
								Dimensions: "5' × 10' × 8'",
								'Best For': 'Single motorcycle',
								'What Fits':
									'Most standard bikes, such as Honda motorcycle storage, with minimal extra space',
								'Monthly Cost Range*': '$40 - $80',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**5x15**',
								},
								Dimensions: "5' × 15' × 8'",
								'Best For': 'Motorcycle + gear',
								'What Fits':
									'One bike plus helmets, riding gear, tools, and accessories',
								'Monthly Cost Range*': '$50 - $100',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**10x10**',
								},
								Dimensions: "10' × 10' × 8'",
								'Best For': 'Large bike or multiple bikes',
								'What Fits':
									'Harley, touring bikes, or 2–3 smaller motorcycles with gear',
								'Monthly Cost Range*': '$70 - $140',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**10x15**',
								},
								Dimensions: "10' × 15' × 8'",
								'Best For': 'Serious riders',
								'What Fits':
									'Multiple motorcycles, extensive gear, workbench for maintenance',
								'Monthly Cost Range*': '$90 - $180',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**10x20**',
								},
								Dimensions: "10' × 20' × 8'",
								'Best For': 'Motorcycle collection',
								'What Fits':
									'3–4 bikes, complete workshop setup, seasonal storage',
								'Monthly Cost Range*': '$110 - $220',
							},
						],
					},
				},
			],
		},

		{
			title: 'video content',
			background: 'dark',
			modules: [
				{
					title: 'Motorcycle Storage Options',
					type: 'content',
					props: {
						title: 'Indoor Motorcycle Storage',
						contentType: 'row-type',
						theme: 'dark',
						ShowBackgroundImage: true,
						contentImage: Indoor,
						content: [
							'This is the most popular motorcycle storage option, as it offers advanced protection from the weather, theft, and other potential risks of bike damage or added maintenance requirements. Some facilities even offer climate-controlled motorcycle storage to make preparing your motorcycle for winter storage a little easier. Many indoor motorcycle storage units feature drive-up access and other conveniences, including 24/7 access to your bike and unit contents.',
						],
					},
				},
			],
		},

		{
			title: 'video content',
			modules: [
				{
					title: 'Motorcycle Storage Options',
					type: 'content',
					props: {
						title: 'Outdoor Motorcycle Storage',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: Outdoor,
						content: [
							'You can store your motorcycle outdoors at a storage facility. Similar to car storage, you also have the option to keep your motorcycle in an open-air parking lot. Some facilities even have awnings over their storage area for added sun protection. If you choose outdoor storage for your motorcycle, your bike will likely be parked in a standard 8x20 space. This is a cheap motorcycle storage option, but it will require extra work for [winterization and long-term storage preparation.](https://sparefoot.com/blog/how-to-winterize-and-store-your-motorcycle)',
						],
					},
				},
			],
		},

		{
			title: 'Motorcycle Storage Prices',
			nopaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Motorcycle Storage Prices',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'#### Indoor Motorcycle Storage Cost\n\n' +
								'Motorcycle storage costs vary depending on factors like unit size, location, amenities, and seasonal demand. Most motorcycle owners opt for indoor storage to balance protection and affordability.',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Dimensions',
								key: 'Dimensions',
							},
							{
								label: 'Standard Indoor',
								key: 'Standard Indoor',
							},
							{
								label: 'Climate-Controlled',
								key: 'Climate-Controlled',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									heading: '5x5',
								},
								Dimensions: "5' × 5' × 8'",
								'Standard Indoor': '$55 ($35 - $75)',
								'Climate-Controlled': '$70 ($50 - $95)',
								'Best For': 'Small bikes, scooters',
							},
							{
								'Unit Size': {
									type: 'icon',
									heading: '5x10',
								},
								Dimensions: "5' × 10' × 8'",
								'Standard Indoor': '$83 ($60 - $110)',
								'Climate-Controlled': '$105 ($80 - $135)',
								'Best For': 'Standard motorcycles',
							},
							{
								'Unit Size': {
									type: 'icon',
									heading: '10x10',
								},
								Dimensions: "10' × 10' × 8'",
								'Standard Indoor': '$136 ($100 - $180)',
								'Climate-Controlled': '$165 ($125 - $220)',
								'Best For': 'Large bikes + gear',
							},
							{
								'Unit Size': {
									type: 'icon',
									heading: '10x15',
								},
								Dimensions: "10' × 15' × 8'",
								'Standard Indoor': '$177 ($130 - $230)',
								'Climate-Controlled': '$215 ($160 - $280)',
								'Best For': 'Multiple bikes',
							},
							{
								'Unit Size': {
									type: 'icon',
									heading: '10x20',
								},
								Dimensions: "10' × 20' × 8'",
								'Standard Indoor': '$225 ($170 - $300)',
								'Climate-Controlled': '$275 ($200 - $360)',
								'Best For': 'Motorcycle collection',
							},
						],
					},
				},
			],
		},

		{
			title: 'Outdoor Motorcycle and Small Vehicle Storage Cost',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'#### Outdoor Motorcycle and Small Vehicle Storage Cost\n\n' +
								'If you’re only looking to store a motorcycle for a short period of time, outdoor storage will give you the best bang for your buck. But remember - outdoor storage won’t protect your motorcycle from extreme weather like excessive heat, hail, rain, or snow. ',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Storage Type',
								key: 'Storage Type',
							},
							{
								label: 'Average Monthly Cost',
								key: 'Average Monthly Cost',
							},
							{
								label: 'Price Range',
								key: 'Price Range',
							},
							{
								label: 'Protection Level',
								key: 'Protection Level',
							},
						],
						rows: [
							{
								'Storage Type': {
									type: 'icon',
									heading: 'Outdoor Uncovered',
								},
								'Average Monthly Cost': '$65',
								'Price Range': '$30 - $100',
								'Protection Level': 'Basic security only',
							},
							{
								'Storage Type': {
									type: 'icon',
									heading: 'Outdoor Covered',
								},
								'Average Monthly Cost': '$100',
								'Price Range': '$50 - $150',
								'Protection Level': 'Some weather protection',
							},
						],
					},
				},
			],
		},

		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Find the Best Motorcycle Storage Unit with SpareFoot',
					},
				},
			],
		},

		{
			title: 'FAQ Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Motorcycle Storage FAQs',
						faqs: motorcycleStorageFAQs,
					},
				},
			],
		},

		{
			title: 'Featured Content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'motorcycle-featured-content',
						contentCards: [
							{
								content:
									'Protect Your Ride: Long-term Motorcycle Storage Tips',
								date: 'September 22, 2025',
								image: Motorcycle1,
								link: 'https://sparefoot.com/blog/how-to-winterize-and-store-your-motorcycle',
								title: 'General Storage Advice',
							},
							{
								content:
									'Proper Storage Tips for Vehicle Batteries',
								date: 'September 26, 2025',
								image: Motorcycle2,
								link: 'https://sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries',
								title: 'General Storage Advice',
							},
							{
								content:
									'How to Find The Right Storage Facility For Your Car, RV, or Boat',
								date: 'October 24, 2025',
								image: Motorcycle3,
								link: 'https://sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat',
								title: 'General Storage Advice',
							},
							{
								content:
									'What Are Climate-Controlled Storage Units?',
								date: 'September 22, 2025',
								image: Motorcycle4,
								link: 'https://sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit',
								title: 'General Storage Advice',
							},
						],
					},
				},
			],
		},

		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'Car',
							'ATV',
							'DirtBike',
							'Bicycle',
							'24Hour',
							'ClimateControl',
							'Electricity',
						],
					},
				},
			],
		},

		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
